import * as React from 'react'
import { FunctionComponent, ReactElement, useState } from 'react'
import { Dialog, DialogSurface, DialogTrigger, makeStyles, Tooltip, TooltipProps } from '@fluentui/react-components'
import { DialogSurfaceProps } from '@fluentui/react-dialog'

export const useDialogStyles = makeStyles({
    dialogHeight: {
        height: '92vh',
    },
})

export type HammockDialogProps<DialogBodyPropsT = unknown> = {
    key?: string | number

    open?: boolean
    setOpen?: (open: boolean) => void
    onDismiss?: () => void

    surfaceProps?: DialogSurfaceProps

    triggerComponent?: () => ReactElement
    tooltipProps?: Partial<TooltipProps> & Pick<TooltipProps, 'content'>

    dialogBody: FunctionComponent<HammockDialogProps<DialogBodyPropsT>>
    dialogBodyProps?: () => DialogBodyPropsT
}

/**
 * The simplest Dialog we can make. It contains an optional DialogTrigger (+ Tooltip) and a simple DialogSurface. Typing can be anything you like.
 *
 * @param props all optional props, except dialogBody.
 */
export default function HammockDialog<DialogBodyPropsT = unknown>(props: HammockDialogProps<DialogBodyPropsT>): ReactElement {
    const [open, setOpen] = useState(false)

    //We set styles on this Dialog in Base.scss
    return (
        <Dialog open={props.open || open} onOpenChange={(_event, data) => (props.setOpen ? props.setOpen(data.open) : setOpen(data.open))}>
            <DialogTrigger disableButtonEnhancement>
                {props.triggerComponent && (
                    <Tooltip key={`${props.key}-1`} relationship={'description'} withArrow {...props.tooltipProps}>
                        {props.triggerComponent?.()}
                    </Tooltip>
                )}
            </DialogTrigger>
            <DialogSurface {...props.surfaceProps}>
                {props.dialogBody ? <props.dialogBody onDismiss={() => (props.setOpen ? props.setOpen(false) : setOpen(false))} {...props} /> : <></>}
            </DialogSurface>
        </Dialog>
    )
}
